import Button from "@components/_Layout/Controls/Button";
import classNames from "classnames";
import isEmpty from "is-empty";
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import toast from "react-hot-toast";
import { isOwner, isPartner, redirectTo } from "@utils/tools";
import { Menu, Transition } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { routes } from "@routes";
import { useAuth, useLoadingScreen, useSession } from "@hooks";

type MenuCustomerProps = {
  //
};

const MenuCustomer: React.FC<MenuCustomerProps> = () => {
  const { user, signout } = useAuth();
  const { authMode } = useSession();
  const [isLogout, setIsLogout] = useState<boolean>(false);

  const handleLogout = () => {
    setIsLogout(true);
    const toastLogout = toast.loading("Déconnexion en cours...");
    signout((err) => {
      if (!err) {
        toast.success("Vous êtes maintenant déconnecté", {
          id: toastLogout,
        });
        redirectTo(window.location.origin);
      } else
        toast.error(err.message, {
          id: toastLogout,
        });
      setIsLogout(false);
    });
  };

  useLoadingScreen(
    isLogout,
    "Déconnexion en cours...",
    "Veuillez patienter quelques instants"
  );

  return user && authMode !== null ? (
    <Menu as="div" className="tw-ml-2 tw-relative">
      {({ open }) => (
        <>
          <Menu.Button className="tw-block tw-h-8">
            <span className="tw-sr-only">Open user menu</span>
            <span className="tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-full tw-bg-gray-400">
              <span className="tw-text-xs tw-font-medium tw-leading-none tw-text-white">
                {!isEmpty(user.lastName) ? user.lastName![0] : ""}
                {!isEmpty(user.firstName) ? user.firstName![0] : ""}
              </span>
            </span>
          </Menu.Button>

          <Transition
            show={open}
            as={Fragment}
            enter="tw-transition tw-ease-out tw-duration-100"
            enterFrom="tw-transform tw-opacity-0 tw-scale-95"
            enterTo="tw-transform tw-opacity-100 tw-scale-100"
            leave="tw-transition tw-ease-in tw-duration-75"
            leaveFrom="tw-transform tw-opacity-100 tw-scale-100"
            leaveTo="tw-transform tw-opacity-0 tw-scale-95"
          >
            <Menu.Items
              static
              className="tw-origin-top-right tw-absolute tw-right-0 tw-mt-2 tw-w-48 tw-rounded tw-shadow-lg tw-bg-white"
              style={{ zIndex: "2" }}
            >
              <Menu.Item>
                <NavLink
                  to={
                    isPartner(authMode)
                      ? routes.partnerArea_accommodations
                      : isOwner(authMode)
                      ? routes.ownerArea_reservations
                      : routes.customerArea_reservations
                  }
                  end
                  className={(navData) =>
                    classNames(
                      navData.isActive ? "tw-text-primary-500" : "",
                      "hover:tw-text-primary-500 tw-flex tw-flex-row hover:tw-rounded-t hover:tw-bg-gray-100 tw-px-4 tw-py-2 tw-text-sm tw-w-full tw-text-left tw-transition-colors tw-duration-200 tw-ease-in-out"
                    )
                  }
                >
                  {isPartner(authMode)
                    ? "Mes hébergements"
                    : "Mes reservations"}
                </NavLink>
              </Menu.Item>
              <Menu.Item>
                <NavLink
                  to={
                    isPartner(authMode)
                      ? routes.partnerArea_info
                      : isOwner(authMode)
                      ? routes.ownerArea_info
                      : routes.customerArea_info
                  }
                  end
                  className={(navData) =>
                    classNames(
                      navData.isActive ? "tw-text-primary-500" : "",
                      "hover:tw-text-primary-500 tw-flex tw-flex-row hover:tw-bg-gray-100 tw-px-4 tw-py-2 tw-text-sm tw-w-full tw-text-left tw-transition-colors tw-duration-200 tw-ease-in-out"
                    )
                  }
                >
                  Mes coordonnées
                </NavLink>
              </Menu.Item>
              <Menu.Item>
                <Button
                  onClick={handleLogout}
                  className="hover:tw-text-primary-500 tw-flex tw-flex-row hover:tw-rounded-b hover:tw-bg-gray-100 tw-px-4 tw-py-2 tw-text-sm tw-w-full tw-text-left tw-transition-colors tw-duration-200 tw-ease-in-out"
                >
                  Déconnexion
                </Button>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  ) : (
    <></>
  );
};

MenuCustomer.propTypes = {
  //
};

export default MenuCustomer;
